import React, { useState } from "react";
import { isHomePage } from "../utils/utils";
import "./styles/TopBanner.css";

import { navigate } from "gatsby";
import GenbuttonTopBanner from "./GenbuttonTopBanner";


const TopBanner = () => {

  const [showBanner, setShowBanner] = useState(true);

  return (
    <>
      {showBanner && (
        <div className="topbannerCont">
          <div className="optionstopBannerDiv">
            <div className="numbersCont">
              <a href="tel:'212-996-6633'" className="linkNumber">
                Call: 212-996-6633
              </a>
              <a href="sms:6464194947" className="linkNumber">
                Text: 646-419-4947
              </a>
            </div>

            <div className="payBilltopBannerText">
              <GenbuttonTopBanner
                event={() => navigate("/pay-bill")}
                text="Pay Bill"
                shadow
                size={"small"}
              />
            </div>
            <div
              className={`${
                isHomePage()
                  ? "PatienttopBannerText"
                  : "PatienttopBannerTextNoneHomePage"
              }`}
            >
              <GenbuttonTopBanner
                link="https://nyga.mygportal.com/PP6-0-0/Account/LogOn"
                text="Patient Portal"
                shadow
                size={"small"}
              />
            </div>

            <div
              className="bookNowtopBannerText"
            >
              <GenbuttonTopBanner
                event={() => navigate("/appointment")}
                text="Book Now"
                shadow
                size={"small"}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TopBanner;
